module.exports = __webpack_public_path__ + "static/media/ic_nav_03.c06848f0.svg";